// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EncounterScribeTestResponse } from './encounter-scribe-test-response';

// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

/** See com.rev360.pms.api.controller.encounter.scribe.EncounterScribeContextResponse */
/* istanbul ignore next */
@GandalfModel
export class EncounterScribeContextResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfProperty({ designType: String })
	generalPrompt!: string | null;

	@GandalfProperty({ designType: PatientNameResponse })
	patient!: PatientNameResponse;

	@GandalfProperty({ designType: String })
	templateName!: string;

	@GandalfArray(EncounterScribeTestResponse)
	tests!: EncounterScribeTestResponse[];

}
